export default function CallHistoryIcon({
  color = "#667085",
  fill = "none",
  width = 22,
  height = 22,
}) {
  const isActive = fill !== "none";

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {isActive ? (
        <>
          {/* 📦 Background */}
          <rect x="3" y="4" width="18" height="16" rx="4" fill={fill} />

          {/* 🕒 Clock */}
          <circle cx="8" cy="10" r="2.2" fill="#fff" />
          <path
            d="M8 9V10.2L9 10.8"
            stroke={fill}
            strokeWidth="1.2"
            strokeLinecap="round"
          />

          {/* 📋 Lines */}
          <rect x="12" y="8" width="6" height="1.5" rx="0.75" fill="#fff" />
          <rect x="12" y="11" width="5" height="1.5" rx="0.75" fill="#fff" />
        </>
      ) : (
        <>
          {/* 📦 Container */}
          <rect
            x="3"
            y="4"
            width="18"
            height="16"
            rx="4"
            stroke={color}
            strokeWidth="2"
          />

          {/* 🕒 Clock */}
          <circle
            cx="8"
            cy="10"
            r="2.5"
            stroke={color}
            strokeWidth="2"
          />
          <path
            d="M8 9V10.5L9.2 11"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />

          {/* 📋 Lines */}
          <path
            d="M12 9H18M12 12H17"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  );
}